export const IDEAS_STATE = {
  SUGGESTED: "SUGGESTED",
  ADJUSTMENT: "ADJUSTMENT",
  EVALUATED: "EVALUATED",
  IMPLEMENTING: "IMPLEMENTING",
  IMPLEMENTED: "IMPLEMENTED",
  REJECTED: "REJECTED",
};
